import './css/index.less'
import Activities from './components/Activities'
import * as activityActions from './actions'
import activityReducer from './reducers'
import ActivitySagas from './sagas'

export default Activities

export { activityActions, activityReducer, ActivitySagas }
